export default __webpack_public_path__ + "static/media/privacy.aeb3ad19.svg";